/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Why_Listening_Compare_Column_LayoutsInputs */

const en_why_listening_compare_column_layouts = /** @type {(inputs: Why_Listening_Compare_Column_LayoutsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Handles tables and complex layouts`)
};

const es_why_listening_compare_column_layouts = /** @type {(inputs: Why_Listening_Compare_Column_LayoutsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entiende tablas y diseños complejos`)
};

/**
* | output |
* | --- |
* | "Handles tables and complex layouts" |
*
* @param {Why_Listening_Compare_Column_LayoutsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const why_listening_compare_column_layouts = /** @type {((inputs?: Why_Listening_Compare_Column_LayoutsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Why_Listening_Compare_Column_LayoutsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_why_listening_compare_column_layouts(inputs)
	return en_why_listening_compare_column_layouts(inputs)
});